import { render, staticRenderFns } from "./AssignmentSectionForm.vue?vue&type=template&id=d3bb4054"
import script from "./AssignmentSectionForm.vue?vue&type=script&lang=ts"
export * from "./AssignmentSectionForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports